import 'react'
import 'react-dom'
import 'react-async-script'
import 'react-google-maps'
import 'redux'
import 'redux-saga'
import 'react-redux'
import 'react-router'
import 'react-router-dom'
import 'react-router-redux'
import 'react-tabs'
import 'react-select'
import 'aws-amplify'
import 'axios'
import 'classnames'
import 'history'
import 'lodash.throttle'
import 'moment'



// WEBPACK FOOTER //
// ./src/vendor.ts